import { Dialog, DialogContent, DialogTitle, List, ListItem, Typography } from '@mui/material';
import BarcodeScanner from '../../components/barcode-scanner/barcode-scanner';
import { useState } from 'react';
import OrdersService from '../../services/OrdersService';
import NotificationService from '../../services/NotificationService';
import { OrderDTO } from '../../api/api';
import { formatDateStringISO } from '../../utils/dateHandling';
import Button from '../../components/button/Button';

export const BarcodeScannerComponent = () => {
  const [code, setCode] = useState('');
  const [status, setStatus] = useState<'initial' | 'success' | 'error'>('initial');
  const [response, setResponse] = useState<OrderDTO>();

  const getOrder = (code: string) => {
    console.log('Sender..', code);
    OrdersService.getOrderInfoByTransferId(code)
      .then((res) => {
        setResponse(res);
        setCode(code);
        NotificationService.success('Done');
        setStatus('success');
      })
      .catch(() => {
        NotificationService.error('Fejl');
      });
  };

  return (
    <>
      <div style={{ height: '100%', width: '100%' }}>
        <BarcodeScanner codeFoundCallback={(code) => getOrder(code)} handleClose={() => {}} />
        {status === 'initial' && <Typography sx={{ marginTop: '20px' }}>Klar til aflæsning</Typography>}
        {status === 'success' && (
          <>
            <Dialog onClose={() => setStatus('initial')} open={status === 'success'}>
              <DialogTitle textAlign="center">Information om ordre</DialogTitle>
              <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <List sx={{ pt: 0 }}>
                  <ListItem>
                    <Typography marginRight={'10px'} fontWeight={'bold'} variant="subtitle2">
                      D365 ordre id:
                    </Typography>
                    <Typography variant="subtitle2">{response?.transferId}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography marginRight={'10px'} fontWeight={'bold'} variant="subtitle2">
                      Work opgave id:
                    </Typography>
                    <Typography variant="subtitle2"> {response?.workTaskId}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography marginRight={'10px'} fontWeight={'bold'} variant="subtitle2">
                      Oprettet dato:
                    </Typography>
                    <Typography variant="subtitle2">{formatDateStringISO(response?.created ?? '')}</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography marginRight={'10px'} fontWeight={'bold'} variant="subtitle2">
                      Oprettet af:
                    </Typography>
                    <Typography variant="subtitle2">{response?.createdByEmail}</Typography>
                  </ListItem>
                  <ListItem sx={{ display: 'flex', alignItems: 'start' }}>
                    <Typography marginRight={'10px'} fontWeight={'bold'} variant="subtitle2">
                      Beskrivelse:
                    </Typography>
                    <Typography variant="subtitle2">{response?.description}</Typography>
                  </ListItem>
                </List>
                <Button
                  onClick={() => {
                    setCode('');
                    setStatus('initial');
                  }}
                >
                  Luk
                </Button>
              </DialogContent>
            </Dialog>
          </>
        )}

        {status === 'error' && (
          <Typography sx={{ marginTop: '20px' }}>{`Fejl: Kunne ikke bekræfte koden ${code}`}</Typography>
        )}
      </div>
    </>
  );
};

export default BarcodeScannerComponent;
